import Vue from "vue";
import { setupI18n } from './i18nSetup'; // Import the i18n setup function
export function loadConsentPreferences() {
    // Assume the document's lang attribute should override the default 'nl' locale if present
    const userLocale = document.documentElement.lang || 'nl';
    const i18n = setupI18n(userLocale);

    // Dynamically import the ConsentPreferences component
    const ConsentPreferences = () => import('./ConsentPreferences.vue');

    // Create and mount the Vue instance
    return new Vue({
        i18n,
        el: '#consent-preferences',
        data: {
            visible: false,
        },
        methods: {
            show() {
                this.visible = true;
            },
            hide() {
                this.visible = false;
            },
        },
        components: {
            ConsentPreferences,
        },
        template: '<ConsentPreferences v-if="visible" @updateVisibility="(visibility) => this.visible = visibility" />',
    });
}
